import { Badge } from "../ui/badge";

function Section({ title, children }) {
  return (
    <div>
      <p className="mono-label text-cyan-400/80">{title}</p>
      <div className="mt-2 text-sm text-slate-300">{children}</div>
    </div>
  );
}

function List({ items }) {
  if (!items?.length) return <p className="text-slate-500 text-sm">—</p>;
  return <ul className="space-y-1.5">{items.map((it, i) => <li key={i} className="flex gap-2"><span className="text-amber-400">•</span><span>{it}</span></li>)}</ul>;
}

export function SystemDetail({ sys }) {
  if (!sys) return null;
  return (
    <div className="space-y-6">
      <div>
        <Badge className="bg-cyan-500/10 text-cyan-400 border-cyan-500/30">Objetivo</Badge>
        <p className="mt-2 text-sm text-slate-300">{sys.objective || "—"}</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <Section title="Responsable">{sys.owner || "—"}</Section>
        <Section title="Backup">{sys.backup || "—"}</Section>
      </div>
      <Section title="Responsabilidades"><List items={sys.responsibilities} /></Section>

      {sys.decision_rights?.length > 0 && (
        <Section title="Derechos de decisión">
          <div className="space-y-3">
            {sys.decision_rights.map((dr, i) => (
              <div key={i} className="rounded-xl border border-white/10 bg-white/[0.02] p-3 text-xs space-y-1">
                {dr.do && <p><span className="text-slate-500">Hace:</span> {dr.do}</p>}
                {dr.decide && <p><span className="text-slate-500">Decide:</span> {dr.decide}</p>}
                {dr.limit && <p><span className="text-slate-500">Límite:</span> {dr.limit}</p>}
                {dr.exception && <p><span className="text-slate-500">Excepción:</span> {dr.exception}</p>}
                {dr.escalate && <p><span className="text-slate-500">Escala a:</span> {dr.escalate}</p>}
                {dr.backup && <p><span className="text-slate-500">Backup:</span> {dr.backup}</p>}
              </div>
            ))}
          </div>
        </Section>
      )}

      <Section title="Procedimiento">
        {sys.procedure?.length ? <ol className="space-y-1.5 list-decimal list-inside">{sys.procedure.map((p, i) => <li key={i}>{p}</li>)}</ol> : <p className="text-slate-500 text-sm">—</p>}
      </Section>
      <div className="grid sm:grid-cols-2 gap-6">
        <Section title="Límites"><List items={sys.limits} /></Section>
        <Section title="Excepciones"><List items={sys.exceptions} /></Section>
        <Section title="Reglas de escalado"><List items={sys.escalation_rules} /></Section>
        <Section title="Checklist"><List items={sys.checklist} /></Section>
        <Section title="Transferencia de conocimiento"><List items={sys.knowledge_transfer} /></Section>
        <Section title="Verificación"><List items={sys.verification} /></Section>
      </div>
      {sys.kpi?.length > 0 && (
        <Section title="KPI">
          <div className="grid sm:grid-cols-2 gap-2">
            {sys.kpi.map((k, i) => <div key={i} className="rounded-xl border border-white/10 bg-white/[0.02] p-3 text-xs"><b className="text-white">{k.name}</b><br /><span className="text-slate-400">{k.target}</span></div>)}
          </div>
        </Section>
      )}
    </div>
  );
}
